// Locale content for PEPE 佩佩.
// Seeds come from content/locales in the asset pack, extended with UI copy.
// English rule: no em dashes (U+2014) or en dashes (U+2013) anywhere.

export const SUPPORTED_LOCALES = ['en', 'zh-CN', 'zh-HK'];

export const LOCALES = {
  en: {
    locale: 'en',
    languageName: 'English',
    shortLabel: 'EN',
    meta: {
      title: 'PEPE \u4F69\u4F69 | Red frog. Yellow chain. Gold rewards.',
      description:
        'PEPE \u4F69\u4F69 is the red frog on the yellow chain. Buy and sell taxes are 2%. Collected tax is split evenly between the Creator Fund and XAUT holder dividends.',
    },
    brand: { name: 'PEPE \u4F69\u4F69', ticker: 'PEPE' },
    nav: { story: 'The Story', tokenomics: 'Tokenomics', gold: 'Gold', memes: 'Memes', contract: 'Contract' },
    hero: {
      badge: 'Launched on Flap.sh Tax Token V2',
      title: 'Red frog. Yellow chain. Gold rewards.',
      body: 'PEPE \u4F69\u4F69 came out of the yellow night market with tea in one hand and gold on his mind.',
      ctaStory: 'Read the story',
      ctaTokenomics: 'See the tax split',
      altPortrait: 'PEPE \u4F69\u4F69 portrait, a hand drawn red frog with green lips on a yellow background',
      chips: ['2% buy tax', '2% sell tax', '50/50 tax split', 'XAUT dividends'],
    },
    marquee: [
      'Red frog. Yellow chain. Gold rewards.',
      'Night market. Yellow rain. Quiet gold.',
      'Half funds the memes. Half funds XAUT dividends.',
      'Same face. Heavier metal.',
      '\u4F69\u4F69 keeps the lantern on.',
      'The chain gets loud. The frog stays calm.',
      'Two percent in. Two percent out.',
    ],
    story: {
      label: 'The Lore',
      title: 'Four chapters. One calm frog.',
      intro: 'PEPE \u4F69\u4F69 is the red frog who appears when the chain turns yellow. The story moves from the night market to the gold vault.',
    },
    lore: {
      nightMarket: {
        chapter: 'Chapter 01',
        title: 'The Night Market',
        body: 'Red lanterns glow after the rain. PEPE \u4F69\u4F69 holds a cup of tea and watches the yellow chain keep moving.',
        alt: 'PEPE \u4F69\u4F69 drinks tea under red lanterns in a yellow night market',
      },
      yellowRain: {
        chapter: 'Chapter 02',
        title: 'The Yellow Rain',
        body: 'Candles flip. The timeline loses its mind. \u4F69\u4F69 takes another sip of tea.',
        alt: 'PEPE \u4F69\u4F69 stays calm while yellow rain falls across the chain city',
      },
      lanternSignal: {
        chapter: 'Chapter 03',
        title: 'The Lantern Signal',
        body: 'One lantern above the blocks. It tells the community that \u4F69\u4F69 is still here. It says nothing about price.',
        alt: 'A red lantern glows above yellow blocks in the night skyline',
      },
      goldVault: {
        chapter: 'Chapter 04',
        title: 'The Gold Vault',
        body: 'Under the market sits a quiet vault. Half of collected tax is allocated to XAUT holder dividends.',
        alt: 'PEPE \u4F69\u4F69 reads a ledger beside stored gold bars in a quiet vault',
      },
    },
    tokenomics: {
      label: 'Tokenomics',
      title: 'Two percent in. Two percent out.',
      platformLabel: 'Launch platform',
      platformValue: 'Flap.sh Tax Token V2',
      buyTaxLabel: 'Buy tax',
      buyTaxValue: '2%',
      sellTaxLabel: 'Sell tax',
      sellTaxValue: '2%',
      splitTitle: 'Where the collected tax goes',
      creatorFundLabel: 'Creator Fund',
      creatorFundValue: '50% of collected tax',
      creatorFundBody: 'For marketing, content, and community development.',
      dividendsLabel: 'XAUT holder dividends',
      dividendsValue: '50% of collected tax',
      dividendsBody: 'Allocated to XAUT holder dividends through the live Flap.sh contracts.',
      clarifier: 'The 50% figure is a split of collected tax. It is not a 50% yield or APY.',
      dependency: 'Dividend size and timing depend on taxable volume and the live contracts.',
      flowNote: 'Check the live contracts for the exact payout flow.',
      visualAlt: 'Diagram of the 2% taxes flowing into one pool that splits evenly between the Creator Fund and XAUT holder dividends',
    },
    goldRoom: {
      label: 'The Gold Room',
      title: 'Half the tax pot goes to XAUT.',
      body: 'Every buy and sell contributes 2%. Half supports the Creator Fund. The other half is allocated to XAUT holder dividends.',
      steps: [
        { title: 'A trade happens', body: 'A 2% tax is collected on every buy and sell.' },
        { title: 'The tax splits', body: 'Half goes to the Creator Fund. Half goes to the XAUT dividend pool.' },
        { title: 'Holders receive XAUT', body: 'Flap.sh handles the dividend flow according to the live contracts.' },
      ],
      factTitle: 'What is XAUT?',
      factBody: 'XAUT is Tether Gold. One token stands for one fine troy ounce of physical gold on a London Good Delivery bar.',
      honest: 'Payout size and timing depend on taxable volume and the live contracts. Check the contract before making any assumptions.',
      videoAlt: 'PEPE \u4F69\u4F69 in the gold vault, animation loop',
    },
    contract: {
      sectionTitle: 'Contract and wallets',
      label: 'Contract address',
      value: '0x4E01229294F453A2e8cDa96eaCBA86B422CC7777',
      creatorFundLabel: 'Creator Fund and Dev wallet',
      creatorFundValue: '0x0597eb60Cc080f77D3C05863668aF23D0e37EEd7',
      copyLabel: 'Copy',
      copiedToast: 'Copied to clipboard',
      pending: 'Live',
      note: 'The contract and Creator Fund wallet are live. Check every character before copying or trading.',
    },
    gallery: {
      label: 'Memes',
      title: 'The Meme Wall',
      intro: 'Grab the art and add your own caption. The files come without text.',
      download: 'Download PNG',
      motionTitle: 'Celebrate loop',
      motionNote: 'Motion honors your reduced motion setting.',
      items: ['Night Market', 'Lantern Signal', 'The Dip', 'Celebrate', 'Tea Time'],
      captions: [
        'Night market. Yellow rain. Quiet gold.',
        '\u4F69\u4F69 keeps the lantern on.',
        'The chain gets loud. The frog stays calm.',
        'Red frog. Yellow chain. Gold rewards.',
        'Tea first. Charts later.',
      ],
      altPrefix: 'Text free meme template:',
    },
    social: {
      title: '\u4F69\u4F69 keeps the lantern on.',
      body: 'Follow the story and join the market chat.',
      telegramCta: 'Join the Telegram',
      xCta: 'Follow on X',
      telegramLabel: 'Telegram',
      xLabel: 'X (Twitter)',
    },
    footer: {
      languageLabel: 'Language',
      risk: 'Meme tokens and smart contracts carry risk. Verify contract details before taking action.',
      affiliation: 'PEPE \u4F69\u4F69 is a community meme project. It is not affiliated with Binance, BNB Chain, Flap.sh, Tether, or XAUT.',
      rights: '\u00A9 2026 PEPE \u4F69\u4F69 community. The art stays hand drawn.',
      backToTop: 'Back to top',
      wordmarkAlt: 'PEPE \u4F69\u4F69 wordmark on a yellow plate',
      sealAlt: 'Tiny \u4F69\u4F69 seal stamp',
    },
  },

  'zh-CN': {
    locale: 'zh-CN',
    languageName: '\u7B80\u4F53\u4E2D\u6587',
    shortLabel: '\u7B80',
    meta: {
      title: 'PEPE \u4F69\u4F69 | \u7EA2\u8272\u4F69\u4F69\uFF0C\u9EC4\u8272\u94FE\u4E0A\uFF0C\u9EC4\u91D1\u5206\u7EA2',
      description:
        'PEPE 佩佩是黄色链上的红色青蛙。一个以故事为主线的 Meme 币：买入收取 2% 税费，卖出收取 2% 税费，所收税费按 50/50 分配给创作者基金与 XAUT 持币分红。',
    },
    brand: { name: 'PEPE \u4F69\u4F69', ticker: 'PEPE' },
    nav: { story: '故事', tokenomics: '代币经济', gold: '黄金', memes: 'Meme 图库', contract: '合约信息' },
    hero: {
      badge: '\u4E8E Flap.sh Tax Token V2 \u542F\u52A8',
      title: '\u7EA2\u8272\u4F69\u4F69\uFF0C\u9EC4\u8272\u94FE\u4E0A\uFF0C\u9EC4\u91D1\u5206\u7EA2\u3002',
      body: '\u4F69\u4F69\u4ECE\u9EC4\u8272\u591C\u5E02\u8D70\u6765\uFF0C\u628A\u6545\u4E8B\u4E00\u8DEF\u5E26\u8FDB\u9EC4\u91D1\u91D1\u5E93\u3002',
      ctaStory: '\u9605\u8BFB\u6545\u4E8B',
      ctaTokenomics: '\u67E5\u770B\u7A0E\u8D39\u5206\u914D',
      altPortrait: 'PEPE \u4F69\u4F69\u753B\u50CF\uFF1A\u9EC4\u8272\u80CC\u666F\u4E0A\u7684\u624B\u7ED8\u7EA2\u8272\u9752\u86D9\uFF0C\u7EFF\u8272\u5634\u5507',
      chips: ['\u4E70\u5165\u7A0E 2%', '\u5356\u51FA\u7A0E 2%', '\u7A0E\u8D39 50/50 \u5206\u914D', 'XAUT \u5206\u7EA2'],
    },
    marquee: [
      '\u7EA2\u8272\u4F69\u4F69\uFF0C\u9EC4\u8272\u94FE\u4E0A\uFF0C\u9EC4\u91D1\u5206\u7EA2\u3002',
      '\u591C\u5E02\u3001\u9EC4\u96E8\u3001\u5B89\u9759\u7684\u9EC4\u91D1\u3002',
      '\u4E00\u534A\u505A\u63A8\u5E7F\uFF0C\u4E00\u534A\u53D1 XAUT\u3002',
      '\u8FD8\u662F\u90A3\u5F20\u8138\uFF0C\u5206\u91CF\u66F4\u91CD\u3002',
      '\u4F69\u4F69\u628A\u706F\u7B3C\u4E00\u76F4\u70B9\u7740\u3002',
      '\u94FE\u4E0A\u518D\u5435\uFF0C\u9752\u86D9\u4E0D\u614C\u3002',
      '\u4E70\u5165 2%\uFF0C\u5356\u51FA 2%\u3002',
    ],
    story: {
      label: '\u6545\u4E8B',
      title: '\u56DB\u4E2A\u7AE0\u8282\uFF0C\u4E00\u53EA\u6DE1\u5B9A\u7684\u9752\u86D9\u3002',
      intro: '\u5F53\u94FE\u53D8\u6210\u9EC4\u8272\uFF0C\u7EA2\u8272\u9752\u86D9\u4F69\u4F69\u5C31\u4F1A\u51FA\u73B0\u3002\u6545\u4E8B\u4ECE\u591C\u5E02\u4E00\u8DEF\u8D70\u5230\u9EC4\u91D1\u91D1\u5E93\u3002',
    },
    lore: {
      nightMarket: {
        chapter: '\u7B2C\u4E00\u7AE0',
        title: '\u591C\u5E02\u521D\u73B0',
        body: '\u96E8\u540E\u7684\u591C\u5E02\u4EAE\u8D77\u7EA2\u706F\u7B3C\u3002\u4F69\u4F69\u7AEF\u7740\u4E00\u676F\u8336\uFF0C\u770B\u7740\u9EC4\u8272\u94FE\u7EE7\u7EED\u8DD1\u3002',
        alt: '\u4F69\u4F69\u5728\u9EC4\u8272\u591C\u5E02\u7684\u7EA2\u706F\u7B3C\u4E0B\u559D\u8336',
      },
      yellowRain: {
        chapter: '\u7B2C\u4E8C\u7AE0',
        title: '\u9EC4\u8272\u98CE\u96E8',
        body: 'K\u7EBF\u4E71\u8DF3\uFF0C\u7FA4\u91CC\u5237\u5C4F\uFF0C\u9EC4\u96E8\u7838\u5728\u644A\u4F4D\u4E0A\u3002\u4F69\u4F69\u53C8\u559D\u4E86\u4E00\u53E3\u8336\u3002',
        alt: '\u9EC4\u8272\u7684\u96E8\u843D\u5728\u94FE\u4E0A\u57CE\u5E02\uFF0C\u4F69\u4F69\u4F9D\u7136\u5E73\u9759',
      },
      lanternSignal: {
        chapter: '\u7B2C\u4E09\u7AE0',
        title: '\u706F\u7B3C\u4FE1\u53F7',
        body: '\u65B9\u5757\u4E0A\u65B9\u6302\u8D77\u4E00\u76CF\u706F\u7B3C\uFF0C\u544A\u8BC9\u793E\u533A\u4F69\u4F69\u8FD8\u5728\u3002\u706F\u7B3C\u53EA\u62A5\u5E73\u5B89\uFF0C\u4E0D\u62A5\u884C\u60C5\u3002',
        alt: '\u591C\u8272\u5929\u9645\u7EBF\u4E0A\uFF0C\u4E00\u76CF\u7EA2\u706F\u7B3C\u4EAE\u5728\u9EC4\u8272\u65B9\u5757\u4E0A\u65B9',
      },
      goldVault: {
        chapter: '\u7B2C\u56DB\u7AE0',
        title: '\u9EC4\u91D1\u91D1\u5E93',
        body: '\u5E02\u573A\u5730\u4E0B\u6DF1\u5904\u662F\u4E00\u95F4\u5B89\u9759\u7684\u91D1\u5E93\u3002\u6240\u6536\u7A0E\u8D39\u7684\u4E00\u534A\u7528\u4E8E XAUT \u6301\u5E01\u5206\u7EA2\u3002',
        alt: '\u4F69\u4F69\u5728\u5B89\u9759\u7684\u91D1\u5E93\u91CC\u7FFB\u770B\u8D26\u672C\uFF0C\u8EAB\u65C1\u662F\u6536\u597D\u7684\u91D1\u6761',
      },
    },
    tokenomics: {
      label: '\u4EE3\u5E01\u7ECF\u6D4E',
      title: '\u4E70\u5165 2%\uFF0C\u5356\u51FA 2%\u3002',
      platformLabel: '\u53D1\u884C\u5E73\u53F0',
      platformValue: 'Flap.sh Tax Token V2',
      buyTaxLabel: '\u4E70\u5165\u7A0E',
      buyTaxValue: '2%',
      sellTaxLabel: '\u5356\u51FA\u7A0E',
      sellTaxValue: '2%',
      splitTitle: '\u6240\u6536\u7A0E\u8D39\u7684\u53BB\u5411',
      creatorFundLabel: '\u521B\u4F5C\u8005\u57FA\u91D1',
      creatorFundValue: '\u6240\u6536\u7A0E\u8D39\u7684 50%',
      creatorFundBody: '\u7528\u4E8E\u5E02\u573A\u63A8\u5E7F\u3001\u5185\u5BB9\u521B\u4F5C\u4E0E\u793E\u533A\u5EFA\u8BBE\u3002',
      dividendsLabel: 'XAUT \u6301\u5E01\u5206\u7EA2',
      dividendsValue: '\u6240\u6536\u7A0E\u8D39\u7684 50%',
      dividendsBody: '\u901A\u8FC7\u5DF2\u4E0A\u7EBF\u7684 Flap.sh \u7A0E\u8D39\u4E0E\u5206\u7EA2\u5408\u7EA6\u8FDB\u884C\u5206\u914D\u3002',
      clarifier: '\u8FD9\u91CC\u7684 50% \u6307\u6240\u6536\u7A0E\u8D39\u7684\u5206\u914D\u6BD4\u4F8B\uFF0C\u4E0D\u662F 50% \u6536\u76CA\u7387\uFF0C\u4E5F\u4E0D\u662F APY\u3002',
      dependency: '\u5206\u7EA2\u91D1\u989D\u548C\u65F6\u95F4\u53D6\u51B3\u4E8E\u5E94\u7A0E\u4EA4\u6613\u91CF\u4E0E\u5408\u7EA6\u8FD0\u884C\u60C5\u51B5\u3002',
      flowNote: '\u5177\u4F53\u5206\u7EA2\u6D41\u7A0B\u4EE5\u94FE\u4E0A\u5408\u7EA6\u4E3A\u51C6\u3002',
      visualAlt: '\u793A\u610F\u56FE\uFF1A2% \u7A0E\u8D39\u6C47\u5165\u540C\u4E00\u6C60\u5B50\uFF0C\u518D\u5E73\u5747\u5206\u914D\u7ED9\u521B\u4F5C\u8005\u57FA\u91D1\u4E0E XAUT \u6301\u5E01\u5206\u7EA2',
    },
    goldRoom: {
      label: '\u9EC4\u91D1\u5C4B',
      title: '\u6240\u6536\u7A0E\u8D39\u7684\u4E00\u534A\uFF0C\u7528\u4E8E XAUT \u5206\u7EA2\u3002',
      body: '\u6BCF\u7B14\u4E70\u5165\u548C\u5356\u51FA\u5747\u6536\u53D6 2% \u7A0E\u8D39\u3002\u4E00\u534A\u8FDB\u5165\u521B\u4F5C\u8005\u57FA\u91D1\uFF0C\u53E6\u4E00\u534A\u7528\u4E8E XAUT \u6301\u5E01\u5206\u7EA2\u3002',
      steps: [
        { title: '\u53D1\u751F\u4E00\u7B14\u4EA4\u6613', body: '\u6BCF\u7B14\u4E70\u5165\u548C\u5356\u51FA\u5747\u6536\u53D6 2% \u7A0E\u8D39\u3002' },
        { title: '\u7A0E\u8D39\u5BF9\u534A\u5206', body: '\u4E00\u534A\u8FDB\u5165\u521B\u4F5C\u8005\u57FA\u91D1\uFF0C\u4E00\u534A\u8FDB\u5165 XAUT \u5206\u7EA2\u6C60\u3002' },
        { title: '\u6301\u5E01\u8005\u83B7\u5F97 XAUT', body: '\u5177\u4F53\u5206\u7EA2\u6D41\u7A0B\u6309\u5DF2\u4E0A\u7EBF\u7684 Flap.sh \u5408\u7EA6\u6267\u884C\u3002' },
      ],
      factTitle: 'XAUT \u662F\u4EC0\u4E48\uFF1F',
      factBody: 'XAUT \u5C31\u662F Tether Gold\u3002\u4E00\u679A\u4EE3\u5E01\u5BF9\u5E94\u4F26\u6566\u5408\u683C\u4EA4\u5272\u91D1\u6761\u4E0A\u7684\u4E00\u91D1\u8861\u76CE\u53F8\u5B9E\u7269\u9EC4\u91D1\u3002',
      honest: '\u5206\u7EA2\u91D1\u989D\u548C\u65F6\u95F4\u53D6\u51B3\u4E8E\u5E94\u7A0E\u4EA4\u6613\u91CF\u4E0E\u5DF2\u4E0A\u7EBF\u7684\u5408\u7EA6\u3002\u8BF7\u76F4\u63A5\u6838\u5BF9\u94FE\u4E0A\u6570\u636E\u3002',
      videoAlt: '\u4F69\u4F69\u5728\u9EC4\u91D1\u91D1\u5E93\u4E2D\u7684\u5FAA\u73AF\u52A8\u753B',
    },
    contract: {
      sectionTitle: '\u5408\u7EA6\u4E0E\u94B1\u5305',
      label: '\u5408\u7EA6\u5730\u5740',
      value: '0x4E01229294F453A2e8cDa96eaCBA86B422CC7777',
      creatorFundLabel: '\u521B\u4F5C\u8005\u57FA\u91D1 / \u5F00\u53D1\u94B1\u5305',
      creatorFundValue: '0x0597eb60Cc080f77D3C05863668aF23D0e37EEd7',
      copyLabel: '\u590D\u5236',
      copiedToast: '\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F',
      pending: '\u5DF2\u4E0A\u7EBF',
      note: '\u5408\u7EA6\u5730\u5740\u4E0E\u521B\u4F5C\u8005\u57FA\u91D1\u94B1\u5305\u73B0\u5DF2\u516C\u5E03\u3002\u590D\u5236\u6216\u4EA4\u6613\u524D\uFF0C\u8BF7\u9010\u5B57\u6838\u5BF9\u3002',
    },
    gallery: {
      label: 'Meme',
      title: 'Meme 墙',
      intro: '\u62FF\u8D70\u56FE\u7247\uFF0C\u52A0\u4E0A\u81EA\u5DF1\u7684\u6587\u6848\u3002\u56FE\u7247\u672C\u8EAB\u4E0D\u5E26\u5B57\u3002',
      download: '\u4E0B\u8F7D PNG',
      motionTitle: '\u5E86\u795D\u52A8\u56FE',
      motionNote: '如果你启用了“减少动态效果”，动画会自动停止。',
      items: ['\u591C\u5E02', '\u706F\u7B3C\u4FE1\u53F7', '\u4E0B\u8DCC\u65F6\u523B', '\u5E86\u795D', '\u996E\u8336'],
      captions: [
        '\u591C\u5E02\u3001\u9EC4\u96E8\u3001\u5B89\u9759\u7684\u9EC4\u91D1\u3002',
        '\u4F69\u4F69\u628A\u706F\u7B3C\u4E00\u76F4\u70B9\u7740\u3002',
        '\u94FE\u4E0A\u518D\u5435\uFF0C\u9752\u86D9\u4E0D\u614C\u3002',
        '\u7EA2\u8272\u4F69\u4F69\uFF0C\u9EC4\u8272\u94FE\u4E0A\uFF0C\u9EC4\u91D1\u5206\u7EA2\u3002',
        '\u5148\u559D\u8336\uFF0C\u518D\u770B\u76D8\u3002',
      ],
      altPrefix: '无字 Meme 模板：',
    },
    social: {
      title: '\u4F69\u4F69\u628A\u706F\u7B3C\u4E00\u76F4\u70B9\u7740\u3002',
      body: '\u8FFD\u8E2A\u6700\u65B0\u6D88\u606F\uFF0C\u8FDB\u7FA4\u4E00\u8D77\u804A\u3002',
      telegramCta: '\u52A0\u5165 Telegram',
      xCta: '\u5173\u6CE8 X',
      telegramLabel: 'Telegram',
      xLabel: 'X\uFF08\u63A8\u7279\uFF09',
    },
    footer: {
      languageLabel: '\u8BED\u8A00',
      risk: 'Meme 币与智能合约均存在风险。采取行动前，请先核对合约信息。',
      affiliation: 'PEPE 佩佩是一个社区 Meme 项目，与 Binance、BNB Chain、Flap.sh、Tether 或 XAUT 均无官方关联。',
      rights: '\u00A9 2026 PEPE \u4F69\u4F69\u793E\u533A\u3002\u753B\u98CE\u4FDD\u6301\u624B\u7ED8\u3002',
      backToTop: '\u56DE\u5230\u9876\u90E8',
      wordmarkAlt: '\u9EC4\u8272\u5E95\u677F\u4E0A\u7684 PEPE \u4F69\u4F69\u5B57\u6807',
      sealAlt: '\u5C0F\u5C0F\u7684\u4F69\u4F69\u5370\u7AE0',
    },
  },

  'zh-HK': {
    locale: 'zh-HK',
    languageName: '\u9999\u6E2F\u7E41\u9AD4',
    shortLabel: '\u7E41',
    meta: {
      title: 'PEPE \u4F69\u4F69 | \u7D05\u8272\u4F69\u4F69\uFF0C\u9EC3\u8272\u93C8\u4E0A\uFF0C\u9EC3\u91D1\u6D3E\u606F',
      description:
        'PEPE 佩佩係黃色鏈上嘅紅色青蛙。一個以故事行先嘅 Meme 幣：買入收 2% 稅項，賣出收 2% 稅項，所收稅項按 50/50 撥入創作者基金同 XAUT 持幣派息。',
    },
    brand: { name: 'PEPE \u4F69\u4F69', ticker: 'PEPE' },
    nav: { story: '故事', tokenomics: '代幣經濟', gold: '黃金', memes: 'Meme 圖庫', contract: '合約資料' },
    hero: {
      badge: '\u55BA Flap.sh Tax Token V2 \u4E0A\u555F\u52D5',
      title: '\u7D05\u8272\u4F69\u4F69\uFF0C\u9EC3\u8272\u93C8\u4E0A\uFF0C\u9EC3\u91D1\u6D3E\u606F\u3002',
      body: '\u4F69\u4F69\u7531\u9EC3\u8272\u591C\u5E02\u884C\u5230\u9EC3\u91D1\u5EAB\u623F\uFF0C\u6210\u500B\u6545\u4E8B\u7531\u71B1\u9B27\u8B8A\u6210\u4EFD\u91CF\u3002',
      ctaStory: '睇下個故事',
      ctaTokenomics: '\u67E5\u770B\u7A05\u9805\u5206\u914D',
      altPortrait: 'PEPE \u4F69\u4F69\u756B\u50CF\uFF1A\u9EC3\u8272\u80CC\u666F\u4E0A\u5605\u624B\u7E6A\u7D05\u8272\u9752\u86D9\uFF0C\u7DA0\u8272\u5634\u5507',
      chips: ['\u8CB7\u5165\u7A05 2%', '\u8CE3\u51FA\u7A05 2%', '\u7A05\u9805 50/50 \u5206\u914D', 'XAUT \u6D3E\u606F'],
    },
    marquee: [
      '\u7D05\u8272\u4F69\u4F69\uFF0C\u9EC3\u8272\u93C8\u4E0A\uFF0C\u9EC3\u91D1\u6D3E\u606F\u3002',
      '\u591C\u5E02\u3001\u9EC3\u96E8\u3001\u5B89\u975C\u5605\u9EC3\u91D1\u3002',
      '\u4E00\u534A\u505A\u63A8\u5EE3\uFF0C\u4E00\u534A\u6D3E XAUT\u3002',
      '\u4EF2\u4FC2\u55F0\u5F35\u81C9\uFF0C\u4EFD\u91CF\u91CD\u5497\u3002',
      '\u4F69\u4F69\u4E00\u76F4\u4EAE\u4F4F\u76DE\u71C8\u7C60\u3002',
      '條鏈幾嘈都好，隻蛙照樣淡定。',
      '\u8CB7\u5165 2%\uFF0C\u8CE3\u51FA 2%\u3002',
    ],
    story: {
      label: '\u6545\u4E8B',
      title: '\u56DB\u500B\u7AE0\u7BC0\uFF0C\u4E00\u96BB\u6DE1\u5B9A\u5605\u9752\u86D9\u3002',
      intro: '\u689D\u93C8\u4E00\u8B8A\u9EC3\uFF0C\u7D05\u8272\u9752\u86D9\u4F69\u4F69\u5C31\u6703\u73FE\u8EAB\u3002\u6545\u4E8B\u7531\u591C\u5E02\u4E00\u8DEF\u884C\u5230\u9EC3\u91D1\u5EAB\u623F\u3002',
    },
    lore: {
      nightMarket: {
        chapter: '\u7B2C\u4E00\u7AE0',
        title: '\u591C\u5E02\u73FE\u8EAB',
        body: '雨後嘅夜市亮起紅燈籠。佩佩捧住一杯茶，靜靜咁睇住條黃色鏈繼續行。',
        alt: '\u4F69\u4F69\u55BA\u9EC3\u8272\u591C\u5E02\u5605\u7D05\u71C8\u7C60\u4E0B\u9762\u98F2\u8336',
      },
      yellowRain: {
        chapter: '\u7B2C\u4E8C\u7AE0',
        title: '\u9EC3\u8272\u98A8\u96E8',
        body: 'K線亂跳，群組洗版，黃雨打落檔口。佩佩又飲多啖茶。',
        alt: '\u9EC3\u8272\u5605\u96E8\u843D\u55BA\u93C8\u4E0A\u57CE\u5E02\uFF0C\u4F69\u4F69\u7167\u6A23\u5E73\u975C',
      },
      lanternSignal: {
        chapter: '\u7B2C\u4E09\u7AE0',
        title: '\u71C8\u7C60\u4FE1\u865F',
        body: '方塊上面掛起一盞燈籠，話畀社群知佩佩仲喺度。盞燈籠只係報平安，唔係報價。',
        alt: '\u591C\u665A\u5929\u969B\u7DDA\u4E0A\u9762\uFF0C\u4E00\u76DE\u7D05\u71C8\u7C60\u4EAE\u55BA\u9EC3\u8272\u65B9\u584A\u4E0A\u65B9',
      },
      goldVault: {
        chapter: '\u7B2C\u56DB\u7AE0',
        title: '\u9EC3\u91D1\u5EAB\u623F',
        body: '\u5E02\u5834\u5730\u5E95\u6DF1\u8655\u6709\u9593\u5B89\u975C\u5605\u9EC3\u91D1\u5EAB\u623F\u3002\u6240\u6536\u7A05\u9805\u5605\u4E00\u534A\u7528\u4F5C XAUT \u6301\u5E63\u6D3E\u606F\u3002',
        alt: '佩佩喺安靜嘅庫房入面睇賬本，旁邊係收好嘅金條',
      },
    },
    tokenomics: {
      label: '\u4EE3\u5E63\u7D93\u6FDF',
      title: '\u8CB7\u5165 2%\uFF0C\u8CE3\u51FA 2%\u3002',
      platformLabel: '\u767C\u884C\u5E73\u53F0',
      platformValue: 'Flap.sh Tax Token V2',
      buyTaxLabel: '\u8CB7\u5165\u7A05',
      buyTaxValue: '2%',
      sellTaxLabel: '\u8CE3\u51FA\u7A05',
      sellTaxValue: '2%',
      splitTitle: '\u6240\u6536\u7A05\u9805\u5605\u53BB\u5411',
      creatorFundLabel: '\u5275\u4F5C\u8005\u57FA\u91D1',
      creatorFundValue: '\u6240\u6536\u7A05\u9805\u5605 50%',
      creatorFundBody: '\u7528\u4F5C\u5E02\u5834\u63A8\u5EE3\u3001\u5167\u5BB9\u88FD\u4F5C\u540C\u793E\u7FA4\u767C\u5C55\u3002',
      dividendsLabel: 'XAUT \u6301\u5E63\u6D3E\u606F',
      dividendsValue: '\u6240\u6536\u7A05\u9805\u5605 50%',
      dividendsBody: '\u7D93\u5DF2\u4E0A\u7DDA\u5605 Flap.sh \u7A05\u9805\u540C\u6D3E\u606F\u5408\u7D04\u5206\u914D\u3002',
      clarifier: '\u5462\u500B 50% \u4FC2\u6307\u6240\u6536\u7A05\u9805\u5605\u5206\u914D\u6BD4\u4F8B\uFF0C\u5514\u4FC2 50% \u56DE\u5831\u7387\uFF0C\u4EA6\u90FD\u5514\u4FC2 APY\u3002',
      dependency: '派幾多、幾時派，要睇實際應課稅交易量同合約運作。',
      flowNote: '\u5BE6\u969B\u6D3E\u606F\u6D41\u7A0B\u4EE5\u93C8\u4E0A\u5408\u7D04\u70BA\u6E96\u3002',
      visualAlt: '示意圖：2% 稅項匯入同一個池，再平均分配畀創作者基金同 XAUT 持幣派息',
    },
    goldRoom: {
      label: '\u9EC3\u91D1\u623F',
      title: '\u6240\u6536\u7A05\u9805\u5605\u4E00\u534A\uFF0C\u7528\u4F5C XAUT \u6D3E\u606F\u3002',
      body: '\u6BCF\u7B46\u8CB7\u5165\u540C\u8CE3\u51FA\u90FD\u6536 2% \u7A05\u9805\u3002\u4E00\u534A\u64A5\u5165\u5275\u4F5C\u8005\u57FA\u91D1\uFF0C\u53E6\u4E00\u534A\u7528\u4F5C XAUT \u6301\u5E63\u6D3E\u606F\u3002',
      steps: [
        { title: '\u6709\u4E00\u7B46\u4EA4\u6613', body: '\u6BCF\u7B46\u8CB7\u5165\u540C\u8CE3\u51FA\u90FD\u6536 2% \u7A05\u9805\u3002' },
        { title: '\u7A05\u9805\u5C0D\u534A\u5206', body: '\u4E00\u534A\u64A5\u5165\u5275\u4F5C\u8005\u57FA\u91D1\uFF0C\u4E00\u534A\u9032\u5165 XAUT \u6D3E\u606F\u6C60\u3002' },
        { title: '\u6301\u5E63\u4EBA\u6536 XAUT', body: '\u5BE6\u969B\u6D3E\u606F\u6D41\u7A0B\u6309\u5DF2\u4E0A\u7DDA\u5605 Flap.sh \u5408\u7D04\u57F7\u884C\u3002' },
      ],
      factTitle: 'XAUT \u4FC2\u54A9\uFF1F',
      factBody: 'XAUT \u5373\u4FC2 Tether Gold\u3002\u6BCF\u500B XAUT \u4EE3\u8868\u502B\u6566\u5408\u683C\u4EA4\u5272\u91D1\u689D\u4E0A\u4E00\u91D1\u8861\u5B89\u58EB\u5BE6\u7269\u9EC3\u91D1\u3002',
      honest: '\u6D3E\u606F\u91D1\u984D\u540C\u6642\u9593\u53D6\u6C7A\u65BC\u5BE6\u969B\u61C9\u8AB2\u7A05\u4EA4\u6613\u91CF\u540C\u5DF2\u4E0A\u7DDA\u5605\u5408\u7D04\u3002\u8ACB\u76F4\u63A5\u6838\u5C0D\u93C8\u4E0A\u8CC7\u6599\u3002',
      videoAlt: '\u4F69\u4F69\u55BA\u9EC3\u91D1\u5EAB\u623F\u5605\u5FAA\u74B0\u52D5\u756B',
    },
    contract: {
      sectionTitle: '\u5408\u7D04\u540C\u9322\u5305',
      label: '\u5408\u7D04\u5730\u5740',
      value: '0x4E01229294F453A2e8cDa96eaCBA86B422CC7777',
      creatorFundLabel: '\u5275\u4F5C\u8005\u57FA\u91D1 / \u958B\u767C\u9322\u5305',
      creatorFundValue: '0x0597eb60Cc080f77D3C05863668aF23D0e37EEd7',
      copyLabel: '\u8907\u88FD',
      copiedToast: '\u5DF2\u8907\u88FD\u5230\u526A\u8CBC\u7C3F',
      pending: '\u5DF2\u4E0A\u7DDA',
      note: '\u5408\u7D04\u5730\u5740\u540C\u5275\u4F5C\u8005\u57FA\u91D1\u9322\u5305\u5DF2\u7D93\u516C\u958B\u3002\u8907\u88FD\u6216\u8005\u4EA4\u6613\u4E4B\u524D\uFF0C\u8A18\u5F97\u9010\u500B\u5B57\u6838\u5C0D\u3002',
    },
    gallery: {
      label: 'Meme',
      title: 'Meme 牆',
      intro: '\u62CE\u8D70\u5572\u5716\uFF0C\u52A0\u8FD4\u81EA\u5DF1\u5605\u5B57\u3002\u5716\u7247\u672C\u8EAB\u5187\u5B57\u3002',
      download: '\u4E0B\u8F09 PNG',
      motionTitle: '\u6176\u795D\u52D5\u756B',
      motionNote: '如果你開咗「減少動態效果」，動畫會自動停低。',
      items: ['\u591C\u5E02', '\u71C8\u7C60\u4FE1\u865F', '\u8DCC\u5E02\u6642\u523B', '\u6176\u795D', '\u98F2\u8336'],
      captions: [
        '\u591C\u5E02\u3001\u9EC3\u96E8\u3001\u5B89\u975C\u5605\u9EC3\u91D1\u3002',
        '\u4F69\u4F69\u4E00\u76F4\u4EAE\u4F4F\u76DE\u71C8\u7C60\u3002',
        '條鏈幾嘈都好，隻蛙照樣淡定。',
        '\u7D05\u8272\u4F69\u4F69\uFF0C\u9EC3\u8272\u93C8\u4E0A\uFF0C\u9EC3\u91D1\u6D3E\u606F\u3002',
        '飲咗茶先，睇盤遲啲。',
      ],
      altPrefix: '無字 Meme 模板：',
    },
    social: {
      title: '\u4F69\u4F69\u4E00\u76F4\u4EAE\u4F4F\u76DE\u71C8\u7C60\u3002',
      body: '\u8FFD\u5BE6\u6700\u65B0\u6D88\u606F\uFF0C\u5165 Telegram \u540C\u5927\u5BB6\u50BE\u3002',
      telegramCta: '\u52A0\u5165 Telegram',
      xCta: '\u8FFD\u8E64 X',
      telegramLabel: 'Telegram',
      xLabel: 'X\uFF08Twitter\uFF09',
    },
    footer: {
      languageLabel: '\u8A9E\u8A00',
      risk: 'Meme 幣同智能合約都有風險。採取行動之前，請先核對合約資料。',
      affiliation: 'PEPE 佩佩係社群 Meme 項目，同 Binance、BNB Chain、Flap.sh、Tether 或者 XAUT 都冇官方關係。',
      rights: '\u00A9 2026 PEPE \u4F69\u4F69\u793E\u7FA4\u3002\u756B\u98A8\u4FDD\u6301\u624B\u7E6A\u3002',
      backToTop: '\u8FD4\u56DE\u9802\u90E8',
      wordmarkAlt: '\u9EC3\u8272\u5E95\u677F\u4E0A\u5605 PEPE \u4F69\u4F69\u5B57\u6A19',
      sealAlt: '\u5C0F\u5C0F\u5605\u4F69\u4F69\u5370\u7AE0',
    },
  },
};
